import React from 'react';
import { Box, Typography } from '@mui/material';
import { usePreviewAgent } from '../hooks';
import { formatPhone } from '../utils';

const AgentContactBar: React.FC = () => {
  const { agentName, officeName, agentPhone } = usePreviewAgent();

  if (!agentName) return null;

  const parts = [
    agentName,
    officeName,
    agentPhone ? formatPhone(agentPhone) : '',
  ].filter(Boolean);

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        py: 2,
        px: { xs: 2, md: 4 },
        textAlign: 'center',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {parts.join(' | ')}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
        See an error? Contact me to make corrections.
      </Typography>
    </Box>
  );
};

export default React.memo(AgentContactBar);
